import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const getTagsByGroupId = createAsyncThunk(
  'chatTag/getTagsByGroupId',
  async ({ business_id, group_id }, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;
      
      const response = await axios.get(
        `${ROOT_URL}/chat-tag/?business_id=${business_id}&group_id=${group_id}`,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false,
  data: [],
  /** `${business_id}::${group_id}` after last success; used for soft loading on revisit/same group. */
  lastFetchedKey: null,
};

const getTagsByGroupIdSlice = createSlice({
  name: 'getTagsByGroupId',
  initialState,
  reducers: {
    resetGetTagsByGroupIdState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.data = [];
      state.lastFetchedKey = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTagsByGroupId.pending, (state, action) => {
        const args = action.meta.arg || {};
        const key = `${args.business_id}::${args.group_id}`;
        state.loading = state.lastFetchedKey !== key;
        state.error = null;
        state.success = false;
      })
      .addCase(getTagsByGroupId.fulfilled, (state, action) => {
        const args = action.meta.arg || {};
        const key = `${args.business_id}::${args.group_id}`;
        state.lastFetchedKey = key;
        state.loading = false;
        state.success = true;
        state.data = action.payload.data || [];
      })
      .addCase(getTagsByGroupId.rejected, (state, action) => {
        const args = action.meta.arg || {};
        const key = `${args.business_id}::${args.group_id}`;
        state.lastFetchedKey = key;
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  }
});

export const { resetGetTagsByGroupIdState } = getTagsByGroupIdSlice.actions;
export default getTagsByGroupIdSlice.reducer; 